<template>
  <v-autocomplete v-model="form.folder_ids"
                  label="Folders"
                  placeholder="Select folder(s)"
                  prepend-icon="fal fa-folder-tree"
                  :items="filteredFolders"
                  chips
                  deletable-chips
                  multiple
                  clearable
                  item-value="id"
                  item-text="name">
    <template v-slot:item="{item: folder}">
      <div class="d-flex">
        <div v-for="ancestor in folder.ancestors"
             :key="ancestor.id"
             class="d-flex px-2">
        </div>
        <v-icon left
                v-if="form.folder_ids.includes(folder.id)">
          fal fa-folder-open
        </v-icon>
        <v-icon left
                v-else>
          fal fa-folder
        </v-icon>
        <div>
          {{ folder.name }}
        </div>
      </div>
    </template>
  </v-autocomplete>
</template>
<script>
import {mapGetters} from 'vuex';

export default {
  props: {
    form: {
      type: Object,
      required: true,
    },
    presentation: {
      type: Object,
      required: false,
    },
  },
  computed: {
    ...mapGetters([
      'folders',
      'team',
      'user',
    ]),
    filteredFolders() {
      return this.folders;
    }
  },
  created() {
    this.fetchData();
  },
  methods: {

    fetchData() {
      this.$store.dispatch('fetchFolders');
    },
  }
}
</script>
